import { NotificationKeys } from '../../../enums/notificationKeys'
import { DownloadDocumentFileType } from '../enums/downloadDocumentFileType'

export const documentDownloadNotificationKey: Record<DownloadDocumentFileType, NotificationKeys> = {
  [DownloadDocumentFileType.XML]: NotificationKeys.ExternalInvoiceDownloadAsXml,
  [DownloadDocumentFileType.PDF]: NotificationKeys.ExternalInvoiceDownloadAsPdf,
}

export const getDocumentDownloadNotificationKey = (fileType: DownloadDocumentFileType): NotificationKeys => {
  return documentDownloadNotificationKey[fileType]
}
